<template>
  <div style="width:100%;float:left;">
    <div style="width:100%;float:left;">
      <search-orders></search-orders>
    </div>
    <div style="width:100%;float:left;">
      <CCard>
        <CCardHeader @click="changeCollapsed()">
          Orders Table
          <div class="card-header-actions">
            <CLink class="card-header-action btn-minimize">
              <CIcon :name="`cil-chevron-${collapsed ? 'bottom' : 'top'}`"/>
            </CLink>
          </div>
        </CCardHeader>
        <CCollapse :show="collapsed" :duration="400">
          <CCardBody>
            <div style="float:right;">
              <CButton size="sm" style="float:left;margin-top:2px;margin-right:2px;" :color="showMine ? 'info' : 'outline-info'" @click="clickShowMine()">Show Mine Only</CButton>
              <v-select style="width:250px;float:left;" :options="options" name="name" v-model="filter"></v-select>
            </div>
            <!-- <h5 style="width:100%;float:left;text-align: center;font-size:13px;">Click on row to go to order</h5> -->
            <div style="width:100%;float:left;text-align:center;">
              <CButton size="sm" class="mt-2" color="info" v-if="!downloadLoading" :disabled="selected.length ? false : true" @click="downloadOrders()">Combine & Email Selected PDF Orders (Max 30)</CButton>
            </div>
            <div style="width:100%;float:left;" v-if="!loading">
              <CButton
                color="primary"
                class="mb-2"
                size="sm"
                :href="csvCode" 
                download="coreui-table-data.csv"
                target="_blank"
              >
                Download Table
              </CButton>
              <CDataTable v-if="orders"
                :items="orders"
                :fields="fields"
                :items-per-page="10"
                pagination
                column-filter
                sorter
                table-filter
                @row-clicked="rowClicked"
                @filtered-items-change="setCurrentItems"
              >
                <template #check-header>
                    <input type="checkbox" :checked="checkAll()" @click="selectAll()" />
                </template>
                <!-- <template #order_id-header>
                    Order#
                </template> -->
                <template #as400_log_number-header>
                    Log#
                </template>
                <template #c="{item}">
                  <td>
                    <div v-if="item.color_coding" style="width:20px;height:20px;" :style="'background-color:' + item.color_coding + ';'"></div>
                  </td>
                </template>
                <template #order_items="{item}">
                  <td>
                    {{ item.order_items }}
                  </td>
                </template>
                <template #po_number="{item}">
                  <td>
                    {{ item.po_number }}
                  </td>
                </template>

                <template #check="{item}">
                  <td>
                    <input type="checkbox" :checked="checkSelected(item)" @click="changeSelected(item)" />
                  </td>
                </template>
                <!-- <template #customer="{item}">
                  <td>
                    {{ item.order.customer_info.customer_name }}
                  </td>
                </template> -->
                <template #status="{item}">
                  <td>
                    <CBadge :color="configureColor(item)">{{ item.status }}</CBadge>
                  </td>
                </template>
                <template #actions="{item}">
                  <td>
                    <!-- <CButton size="sm" color="primary" @click="goToOrder( item )">View</CButton> -->
                    <div style="width:100px;">
                      <CButton size="sm" style="float:left;" color="primary" @click="quickView( item )"><CIcon name="cil-fullscreen" /></CButton>
                      <CButton size="sm" style="float:left;" color="success" @click="goToOrder( item )"><CIcon name="cil-arrow-right" /></CButton>
                    </div>
                  </td>
                </template>
              </CDataTable>
            </div>
            <small-loader v-else></small-loader>
          </CCardBody>
        </CCollapse>
      </CCard>
    </div>
    <adobe-pdf-viewer v-if="pdfModal && pdfData" @closed="pdfModal = false, pdfData = null" :order_group="pdfData" pdf_type="either" :allowEdit="false"></adobe-pdf-viewer>
  </div>
</template>
<script>
import SearchOrders from './../components/search_orders'
import AdobePdfViewer from './../components/adobe_pdf_viewer'
var methods = {}

methods.quickView = function (item) {
  console.log('ITEM beig passssed to PDF viewer: ', item)
  this.pdfData = item
  this.pdfModal = true
}

methods.rowClicked = function (item, e, z) {
  console.log(item)
  console.log(z)
  if (z !== 'check' && z !== 'actions') {
    this.$router.push('/order/' + item.order_id + '/' + item.order_group_id)
  }
}

methods.checkSelected = function (item) {
  if (this.selected.indexOf(item.order_group_id) > -1) {
    return 1
  } else {
    return 0
  }
}

methods.checkAll = function () {
  if (this.selected.length) {
    return 1
  } else {
    return 0
  }
}

methods.changeCollapsed = function () {
  this.collapsed = !this.collapsed
  if (this.collapsed) {
    this.getOrders()
  }
}

methods.changeSelected = function (item) {
  if (this.selected.indexOf(item.order_group_id) > -1) {
    this.selected.splice(this.selected.indexOf(item.order_group_id), 1)
  } else {
    this.selected.push(item.order_group_id)
  }
}

methods.selectAll = function () {
  if (this.selected.length) {
    this.selected = []
  } else {
    var arr = []
    this.orders.forEach(function (val) {
      arr.push(val.order_group_id)
    })
    this.selected = arr
  }
}

methods.configureColor = function (item) {
  if (item) {
    var percent = ''
    switch(item.status) {
      case 'Entered': {
        percent = 'info'
        break
      }
      case 'Needs Entered': {
        percent = 'secondary'
        break
      }
      case 'Waiting On Customer': {
        percent = 'danger'
        break
      }
      case 'Received': {
        percent = 'info'
        break
      }
      case 'In Process': {
        percent = 'danger'
        break
      }
      case 'Shipped': {
        percent = 'success'
        break
      }
      case 'On Hold': {
        percent = 'warning'
        break
      }
      case 'Voided': {
        percent = 'warning'
        break
      }
      case 'Canceled': {
        percent = 'danger'
        break
      }
      default: {
        percent = ''
        break
      }
    }
    return percent
  } else {
    return 0
  }
}

methods.getOrders = function () {
  this.loading = true
  const postData = {
    filter: this.filter,
    csr_selected: this.csr_selected,
    showMine: this.showMine
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/getOrdersTable?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    // this.orders = response.data
    var arr = []
    // response.data.forEach(function (val) {
    //   var obj = {}
    //   for (var key in val) {
    //     obj[key] = val[key]
    //   }
    //   var price = 0
    //   var units = 0
    //   val.order_items.forEach(function (item) {
    //     price += parseFloat(item.total_price)
    //     units += parseInt(item.units)
    //   })
    //   obj.as400_log_number = val.as400_log_number
    //   obj.order_id = val.order.order_id
    //   obj.po_number = val.order.po_number
    //   obj.customer_name = val.order.customer_info.customer_name
    //   obj.customer_number = val.order.customer_info.customer_number
    //   obj.rep_name = val.order.rep ? val.order.rep.name : ''
    //   obj.cc_number = val.cc_number ? val.cc_number : ''
    //   obj.order_items = val.order_items.length
    //   obj.color_coding = val.color_coding
    //   obj.order_group_id = val.order_group_id
    //   obj.status = val.as400_status
    //   obj.price = '$' + price.toFixed(2)
    //   obj.units = units
    //   obj.ship_date = val.ship_date
    //   obj.local_created_at = val.local_created_at
    //   arr.push(obj)
    // })
    this.orders = response.data
    this.currentItems = response.data
    this.selected = []
    this.loading = false
  })
}

methods.goToOrder = function (item) {
  // this.$router.push('/order/' + item.order_id + '/' + item.order_group_id)
  window.open(this.$hostAddress + 'order/' + item.order_id + '/' + item.order_group_id)
}

methods.clickShowMine = function () {
  this.showMine = !this.showMine
  window.localStorage.setItem('csrShowMine', this.showMine)
  this.getOrders()
}

methods.downloadOrders = function () {
  this.downloadLoading = true
    const postData = {
      orders: this.selected
    }
    axios.post(this.$apiAdress + '/api/orders/downloadAllOrdersOnPdf?token=' + localStorage.getItem('api_token'), postData).then(response => {
      console.log(response)
      this.downloadLoading = false
      window.Swal.fire({
        type: 'success',
        title: 'Success',
        text: 'You will be emailed the orders shortly.'
      })
      this.selected = []
    }).catch(e => {
      console.log(e)
      window.Swal.fire({
        type: 'error',
        title: 'Error!',
        text: 'Something went wrong, please contact acoleman@paifashion.com if it keeps happening.'
      })
    })
}

methods.setCurrentItems = function (val) {
  this.currentItems = val
}

export default {
    // ===Component name
    name: "CSRTable",
    // ===Props passed to component
    props: ['fromDash'],
    // ===Components used by this component
    components: {
      SearchOrders,
      AdobePdfViewer
    },
    // ====component Data properties
    data(){
        return{
          orders: null,
          fields: ['check', 'c', 'as400_log_number', 'cc_number', 'po_number', 'rep_name', 'customer_number', 'customer_name', 'program_name', 'local_created_at', 'ship_date', 'price', 'units', 'item_count', 'status', 'actions'],
          csvFields: [
            'color_coding',
            'as400_log_number',
            'cc_number',
            'po_number',
            'rep_name',
            'customer_number',
            'customer_name',
            'program_name',
            'price',
            'units',
            'item_count',
            'status',
          ],
          options: ['Last 15 Days', 'Last 30 Days', 'Last 60 Days', 'All'],
          loading: true,
          filter: 'Last 15 Days',
          pdfData: '',
          pdfModal: '',
          showMine: false,
          downloadLoading: false,
          selected: [],
          collapsed: false,
          currentItems: []
        }
    },
    watch: {
      'filter': function (newVal, oldVal) {
        this.getOrders()
      }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      if (this.fromDash) {
        this.collapse = false
      } else {
        this.collapsed = true
        this.getOrders()
      }
      if (window.localStorage.getItem('csrShowMine')) {
        this.showMine = JSON.parse(window.localStorage.getItem('csrShowMine'))
        // this.getOrders()
      } else {
        // this.getOrders()
      }
    },
    // ===Computed properties for the component
    computed: {
      // currentItems() {
      //   if (this.orders) {
      //     return this.orders.slice()
      //   } else {
      //     return ''
      //   }
      // },
      csvContent () {
        // console.log(this.currentItems)
        var content = this.currentItems
        var headers = []
        var that = this
        this.csvFields.forEach(function (f) {
          headers.push('' + f)
        })
        var arr = []
        arr.push(headers)
        this.currentItems.forEach(function (val) {
          var o = {}
          that.csvFields.forEach(function (field) {
            o[field] = val[field]
          })
            arr.push(o)
        })
        return arr.map(item => Object.values(item).join(',')).join('\n')
      },
      csvCode () {
        return 'data:text/csv;charset=utf-8,' + encodeURIComponent(this.csvContent)
      }
    },
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
